import { AutogenLayoutMultiAssignCarrierQual } from "./autogen/AutogenLayoutMultiAssignCarrierQual";

export class MultiAssignCarrierQual extends AutogenLayoutMultiAssignCarrierQual {

}